// extracted by mini-css-extract-plugin
module.exports = {"text":"claimCreate_text__21m7O","grow":"claimCreate_grow__13ln2"};